<app-page-heading [title]="title"></app-page-heading>

<section class="container-fluid" *ngIf="loadedTrace">

    <div class="ibox col-12">
        <div class="ibox-title">HTTP Traces</div>
        <div class="ibox-content widget-body-table">
            <div class="widget-body-row" *ngFor="let trace of traces">
                <div class="trace-path">
                    <span class="badge " [ngClass]="isTrace2xx(trace) ? 'badge-success' : 'badge-danger'">
                        {{trace.info.headers.response.status}}
                    </span>
                    -
                    <span class="badge " [ngClass]="{ 'badge-secondary': trace.info.method === 'OPTIONS', 'badge-primary': trace.info.method === 'GET', 'badge-success': trace.info.method === 'POST', 'badge-warning': trace.info.method === 'PUT', 'badge-danger': trace.info.method === 'DELETE' }">
                        {{trace.info.method}}
                    </span>
                    -
                    <span class="trace-path-path"><code>{{trace.info.path}}</code></span>
                </div>
                <div class="trace-timestamp"><i class="fa fa-clock-o"></i> {{trace.timestamp | timestamp}}</div>
                <div>
                    <button class="btn btn-primary btn-sm" (click)="showFullTrace(trace)">See full trace</button>
                </div>
                <div class="trace-full-trace" *ngIf="trace.showFullTrace">
                    <pre>{{trace.info | json}}</pre>
                </div>
            </div>
            <div *ngIf="traces.length === 0" class="widget-body-row">
                <em>No data yet</em>
            </div>
        </div>
    </div>

</section>
